<template id="orgUsersTmpl">
		<div>
			
			<v-btn class="button-main ma-1" v-on:click="openNewUser()"><v-icon left dark>add</v-icon>{{ $t('btn.addUser')}}</v-btn>

			<v-data-table :headers="orgUsersListHeaders" :items="orgUsersList" :no-data-text="$t('err.noelem')" :loading="$root.loading" class="elevation-1">
				<template v-slot:body="{ items }">
					<tbody>
					<tr v-for="item in items" :key="item.username" >
						<td class="font-weight-bold">{{item.username}}</td>
						<td class="font-weight-bold">{{item.name}}</td>
						<td class="font-weight-bold">{{item.email}}</td>
						<td width="20%" class="text-right">
							<v-tooltip top> 
								<template v-slot:activator="{ on, attrs }">
									<v-btn 
										class="button-secondary ma-1" fab small depressed 
										v-bind="attrs"
										v-on="on" 
										v-on:click="openEditUser(item.username)"
										><v-icon>create</v-icon></v-btn>
								</template>
								<span>{{ $t('btn.edit')}}</span>
							</v-tooltip>	

							<v-tooltip top v-if="isAdmin(item) == false"> 
								<template v-slot:activator="{ on, attrs }">
									<v-btn 
										class="button-secondary ma-1" fab small depressed
										v-bind="attrs"
										v-on="on"  
										v-on:click="deleteUser(item.username)"
										><v-icon>delete</v-icon></v-btn>
								</template>
								<span>{{ $t('btn.delete')}}</span>
							</v-tooltip>			
						</td>
					</tr>
					</tbody>
				</template>
			</v-data-table>
			
			<!-- FORM EDIT USER START -->
			<v-dialog v-model="dialogEditUserIsOpen" persistent max-width="500px">
				<v-form ref="editUserFrm" v-model="validEditFrm" lazy-validation>
					<v-card>
						<v-card-title><span class="headline">{{ $t('lbl.editUser')}}</span></v-card-title>

						<v-card-text v-if="userToEdit != null">
							<v-layout row wrap>
								<v-flex xs12><v-text-field v-model="userToEdit.name" :label="$t('lbl.userName')" :rules="nameRules"></v-text-field></v-flex>
								<v-flex xs12><v-text-field v-model="userToEdit.email" :label="$t('lbl.userEmail')" :rules="emailRules"></v-text-field></v-flex>
								<v-flex xs12>
									<v-text-field v-model="userToEdit.password" :label="$t('lbl.userPwd')" :rules="passwordEditRules"></v-text-field>
									<br/>{{ $t('lbl.ifPwdEmpty')}}
								</v-flex>
							</v-layout>	
						</v-card-text>

						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn class="button-main ma-1" v-on:click="closeEditUser()"><v-icon left dark>close</v-icon>{{ $t('btn.closeDialog')}}</v-btn>
							<v-btn class="button-main ma-1" v-on:click="editUser()"><v-icon left dark>cloud_upload</v-icon>{{ $t('btn.save')}}</v-btn>
						</v-card-actions>
				</v-card>
				</v-form>
			</v-dialog>
			<!-- FORM EDIT USER END -->

			<!-- FORM NEW USER START -->
			<v-dialog v-model="dialogCreateUserIsOpen" persistent max-width="500px">

				<v-form ref="createUserFrm" v-model="validCreateFrm" lazy-validation>
					<v-card>
						<v-card-title><span class="headline">{{ $t('lbl.newUser')}}</span></v-card-title>

						<v-card-text>
							<v-layout row wrap>
								<v-flex xs12><v-text-field v-model="newUser.name" :label="$t('lbl.userName')" :rules="nameRules"></v-text-field></v-flex>
								<v-flex xs12><v-text-field v-model="newUser.username" :label="$t('lbl.userUsername')" :rules="usernameRules"></v-text-field></v-flex>
								<v-flex xs12><v-text-field v-model="newUser.email" :label="$t('lbl.userEmail')" :rules="emailRules"></v-text-field></v-flex>
								<v-flex xs12><v-text-field v-model="newUser.password" :label="$t('lbl.userPwd')" :rules="passwordRules"></v-text-field></v-flex>
							</v-layout>	
						</v-card-text>

						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn class="button-main ma-1" v-on:click="closeNewUser()"><v-icon left dark>close</v-icon>{{ $t('btn.closeDialog')}}</v-btn>
							<v-btn class="button-main ma-1" v-on:click="createNewUser()"><v-icon left dark>cloud_upload</v-icon>{{ $t('btn.save')}}</v-btn>
						</v-card-actions>
					</v-card>
				</v-form>

			</v-dialog>
			<!-- FORM NEW USER END -->



			
		</div>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
	i18n,
     data: () => ({
		orgUsersList: [],
		orgUsersListHeaders: [
			{ text: i18n.t('lbl.userUsername'), align: 'left', value: 'username'},
			{ text: i18n.t('lbl.userName'), align: 'left', value: 'name'},
			{ text: i18n.t('lbl.userEmail'), align: 'left', value: 'email'},
			{ text: '', align: 'center'} 
		],
		dialogCreateUserIsOpen: false,
		newUser: {name: '', username: '', email: '', password: ''},
		validCreateFrm:false,
		dialogEditUserIsOpen: false,
		userToEdit:null,
		validEditFrm: false,
		nameRules: [
			v => !!v || i18n.t('err.fieldNotValid'),
			v => v.length > 0 || i18n.t('err.fieldNotValid')
		],
		usernameRules: [
			v => !!v || i18n.t('err.fieldNotValid'),
			v => v.length > 0 || i18n.t('err.fieldNotValid')
		],
		emailRules: [
			v => !!v || i18n.t('err.fieldNotValid'),
			//v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || i18n.t('err.fieldNotValid')
			v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || i18n.t('err.fieldNotValid')
		],
		passwordRules: [
			v => !!v || i18n.t('err.fieldPwdNotValid'),
			v => v.length > 8 || i18n.t('err.fieldPwdNotValid'),
			v => /.*\d+/.test(v) || i18n.t('err.fieldPwdNotValid')
		],
		passwordEditRules: [
			v => /^\s*$|^(?=.{8,}$)\D*\d/.test(v) || i18n.t('err.fieldPwdNotValid')	
		],
		
	}),
	props: ['orgitem'],
	created() {
		events.$on(constants.EVENT_CHANGE_LOCALE, () => {
			this.orgUsersListHeaders = [
				{ text: i18n.t('lbl.userUsername'), align: 'left', value: 'username'},
				{ text: i18n.t('lbl.userName'), align: 'left', value: 'name'},
				{ text: i18n.t('lbl.userEmail'), align: 'left', value: 'email'},
				{ text: '', align: 'center'}
			];
		});
		events.$on('newUserOrgCreated', () => {
			this.loadUsers();
		});
	},
	destroyed() {
		events.$off('newUserOrgCreated');
		events.$off(constants.EVENT_CHANGE_LOCALE);
	},
	mounted(){
		this.loadUsers();
	},	
	components: {
        
	},
	methods: {
		isAdmin(userObj) 
		{
			if(!this.isEmptyObj(userObj))
			{
				if(!this.isEmptyObj(userObj.roles) && Array.isArray(userObj.roles) && userObj.roles.includes("CTP_Admins"))
				{
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		},
		loadUsers() 
		{
			var endpoint2go = constants.ENDPOINT_USER + '?organization_id=' + this.orgitem.organization_id;
			this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadUsers, 'err.loadingUsers');
		},
		callbackLoadUsers(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.orgUsersList = responseData.users;
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingUsers"));
			}
		},
		openNewUser()
		{
			this.dialogCreateUserIsOpen = true;
		},
		closeNewUser()
		{
			this.dialogCreateUserIsOpen = false;
		},	
		openEditUser(username)
		{
			if(!this.isEmptyString(username))
			{
				var endpoint2go = constants.ENDPOINT_USER + '/'+ username;
				this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackOpenEditUser, 'err.loadingUser') 
			}
		},
		callbackOpenEditUser(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.userToEdit =  { 
					"name":  responseData.name,  
					"organization_id":  responseData.organization_id,  
					"password": '',  
					"username": responseData.username,  
					"email": responseData.email  
				};
				this.dialogEditUserIsOpen = true;
			} 
			else 
			{
				this.$root.setDialogMsg(i18n.t('err.loadingUser'));
			}
		},	
		closeEditUser()
		{
			this.dialogEditUserIsOpen = false;
			this.userToEdit = null;
		},	
		deleteUser(username)
		{
			if(!this.isEmptyString(username))
			{
				if(confirm(i18n.t('lbl.user') + " " +username + " - " + i18n.t('msg.confirmDelete')))
				{	

					var endpoint2go = constants.ENDPOINT_USER + '/'+ username;
					this.$root.genericDeleteAuthenticatedCallEngine(endpoint2go, this.callbackDeleteUser, 'err.deleteUser');
				}
			}	
		},
		callbackDeleteUser(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.loadUsers();
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.deleteUser"));
			}
		},
		editUser()
		{
			// NON USO I METODI GENERAL PERCHE DEVO GESTIRE ERRORI PERSONALIZZATI
			// ATTENZIONE USO LA PATCH
			if (this.$refs.editUserFrm.validate()) 
			{
				this.$root.loading = true;
				
				var endpoint2go = constants.ENDPOINT_USER + '/'+ this.userToEdit.username;


				var myUser = this.getUser();

				//=== SENZA PWD
				var obj2send = {
					"name": this.userToEdit.name,
					"organization_id": this.userToEdit.organization_id,
					"username": this.userToEdit.username,
					"email": this.userToEdit.email,
				}
				
				// === CON PWD
				if(!this.isEmptyString(this.userToEdit.password)){
					obj2send = {
						"name": this.userToEdit.name,
						"organization_id": this.userToEdit.organization_id,
						"username": this.userToEdit.username,
						"email": this.userToEdit.email,
						"password": this.userToEdit.password,
					}
				}

				this.axios
					.patch(endpoint2go, obj2send, this.getMyAuthHeader(myUser) )
					.then(response => {
						try{
							if(!this.isEmptyObj(response) && !this.isEmptyObj(response.status))
							{
								if(response.status == 200)
								{
									this.userToEdit = null;
									this.dialogEditUserIsOpen= false;
									this.$root.setDialogMsg(i18n.t('msg.saveok'));
									this.loadUsers();
								} 
								else if(response.status == 400)
								{
									console.log(response);
									this.userToEdit = null;
									this.dialogEditUserIsOpen= false;
									
									if(!this.isEmptyObj(response.data.type))
									{
										if(response.data.type == 'InvalidPasswordException')
										{
											this.$root.setDialogMsg(response.data.message);
										} 
										else if(response.data.type == 'UsernameExistsException')
										{
											this.$root.setDialogMsg(i18n.t('err.usernameExists'));
										}
										else 
										{
											this.$root.setDialogMsg(response.data.type + ": " + response.data.message);
										}
									} 
									else 
									{
										this.$root.setDialogMsg(i18n.t('err.savingUser'));
									}
								} 
								else if(response.status == 401)
								{
									this.$root.tokenExpired();
								} 
								else 
								{
									this.$root.setDialogMsg(i18n.t('err.savingUser'));
								}
							} 
							else 
							{
								console.log(response);
								this.$root.setDialogMsg(i18n.t('err.savingUser'));
							}
						} 
						finally { 
							this.$root.loading = false; 
						}									
					})
					.catch(error => { 
						this.$root.loading = false; 
						console.log(error);
						this.$root.setDialogMsg(i18n.t('err.savingUser'));
					});
					


			}
		},
		createNewUser() {
			try{
				// NON USO I METODI GENERAL PERCHE DEVO GESTIRE ERRORI PERSONALIZZATI
				if (this.$refs.createUserFrm.validate()) 
				{
					// OVERRIDE ORGANIZATION ID
					this.newUser.organization_id = this.orgitem.organization_id;
					if(!this.isEmptyString(this.newUser.organization_id))
					{
						this.$root.loading = true;

						//console.log("CREATE NEW USER: " + constants.ENDPOINT_USER);	
						//console.log(JSON.stringify(this.newUser));

						var myUser = this.getUser();

						this.axios
							.post(constants.ENDPOINT_USER, this.newUser, this.getMyAuthHeader(myUser) )
							.then(response => {
								try{
									if(response.status == 200)
									{
										this.dialogCreateUserIsOpen= false;
										this.$root.setDialogMsg(i18n.t('msg.saveok'));
										this.loadUsers();
									} 
									else if(response.status == 400)
									{
										console.log(response);
										this.dialogCreateUserIsOpen= false;
										
										if(!this.isEmptyObj(response.data.type))
										{
											if(response.data.type == 'InvalidPasswordException')
											{
												this.$root.setDialogMsg(response.data.message);
											} 
											else if(response.data.type == 'UsernameExistsException')
											{
												this.$root.setDialogMsg(i18n.t('err.usernameExists'));
											}
											else 
											{
												this.$root.setDialogMsg(response.data.type + ": " + response.data.message);
											}
										} 
										else 
										{
											this.$root.setDialogMsg(i18n.t('err.savingUser'));
										}
									} 
									else if(response.status == 401)
									{
										this.$root.tokenExpired();
									} 
									else 
									{
										this.$root.setDialogMsg(i18n.t('err.savingUser'));
									}
								} 
								finally { 
									this.$root.loading = false; 
								}									
							})
							.catch(error => { 
								this.$root.loading = false; 
								this.$root.setDialogMsg(i18n.t('err.savingUser'));
								console.log(error);
							});
					} 
					else 
					{
						console.log("ORGANIZATION ID NOT VALID");
						this.$root.setDialogMsg(i18n.t('err.savingUser'));
					}
				}
			} catch(error) 
			{ 
				this.$root.loading = false; 
				this.$root.setDialogMsg(i18n.t('err.savingUser'));
				console.log(error);
			}
		}
	}
}
</script>